"use client";

import { GenericListPage, type GenericListConfig } from "@admin/_components/generic-list-page";

const config: GenericListConfig = {
  title: "Quizzes",
  subtitle: "Manage training quizzes",
  listEndpoint: "admin/quiz-list",
  countEndpoint: "admin/quiz-list-count",
  statusEndpoint: "admin/quiz-status-change",
  deleteEndpoint: "admin/quiz-delete",
  addPath: "/admin/training/quizzes/add",
  editPath: "/admin/training/quizzes/edit",
  addButtonLabel: "+ Add Quiz",
  // Task 01: preview via admin/quiz-preview, shows question + all answers with correct flag
  previewEndpoint: "admin/quiz-preview",
  previewFields: [
    { key: "question", label: "Question" },
    { key: "lesson_name", label: "Lesson" },
    { key: "priority", label: "Priority" },
    { key: "status", label: "Status", type: "badge" },
    { key: "answers", label: "Answers", type: "answers" },
  ],
  columns: [
    { key: "question", label: "Question", sortable: true },
    { key: "lesson_name", label: "Lesson" },
    { key: "priority", label: "Priority", type: "number" },
    { key: "status", label: "Status", type: "status" },
    { key: "createdon_datetime", label: "Created At", type: "date", sortable: true },
  ],
  searchFields: [
    { label: "Question", field: "question", placeholder: "Search by question..." },
  ],
  filterFields: [
    { label: "Status", field: "status", values: [{ val: "1", name: "Active" }, { val: "0", name: "Inactive" }] },
  ],
};

export default function QuizzesPage() {
  return <GenericListPage config={config} />;
}
